import React, { useEffect, useState, useRef } from 'react';
import { ShoppingCartIcon } from 'lucide-react';
import { useCurrency } from '../context/CurrencyContext';
import { formatPrice } from '../utils/formatCurrency';
import { trackPixelEvent } from './MetaPixel';
export function FloatingCta() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasPricingSectionBeenViewed, setHasPricingSectionBeenViewed] = useState(false);
  const [isPricingSectionVisible, setIsPricingSectionVisible] = useState(false);
  const [isFooterVisible, setIsFooterVisible] = useState(false);
  const {
    currency,
    isLoading
  } = useCurrency();
  const basePrice = 10299;
  // References to observers
  const pricingSectionObserver = useRef(null);
  const footerObserver = useRef(null);
  // Handle add to cart event
  const handleAddToCart = () => {
    trackPixelEvent('AddToCart', {
      value: basePrice,
      currency: 'ARS',
      content_name: 'Método Milhojas Perfecta',
      content_ids: ['M101869446L'],
      content_type: 'product'
    });
  };
  useEffect(() => {
    // Create an Intersection Observer to detect when pricing section is visible
    const pricingObserver = new IntersectionObserver(entries => {
      const [entry] = entries;
      setIsPricingSectionVisible(entry.isIntersecting);
      // If pricing section becomes visible, mark it as having been viewed
      if (entry.isIntersecting) {
        setHasPricingSectionBeenViewed(true);
      }
    }, {
      threshold: 0.1
    });
    // Create an Intersection Observer to detect when footer is visible
    const footerObserverInstance = new IntersectionObserver(entries => {
      const [entry] = entries;
      setIsFooterVisible(entry.isIntersecting);
    }, {
      threshold: 0.1
    });
    // Find the elements to observe
    const pricingSection = document.getElementById('comprar');
    const footer = document.querySelector('footer');
    if (pricingSection) {
      pricingObserver.observe(pricingSection);
      pricingSectionObserver.current = pricingObserver;
    }
    if (footer) {
      footerObserverInstance.observe(footer);
      footerObserver.current = footerObserverInstance;
    }
    // Cleanup function
    return () => {
      if (pricingSectionObserver.current && pricingSection) {
        pricingSectionObserver.current.unobserve(pricingSection);
      }
      if (footerObserver.current && footer) {
        footerObserver.current.unobserve(footer);
      }
    };
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      // Show button when user scrolls down 300px
      const scrollPosition = window.scrollY;
      if (scrollPosition > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Button should be visible only when:
  // 1. User has scrolled down enough (isVisible is true)
  // 2. User has NEVER viewed the pricing section (hasPricingSectionBeenViewed is false)
  const shouldShowButton = isVisible && !hasPricingSectionBeenViewed;
  return <div className={`fixed bottom-4 left-0 right-0 z-50 flex justify-center transition-transform duration-300 ${shouldShowButton ? 'translate-y-0' : 'translate-y-24'}`} data-id="element-129"></div>;
}